import styled from "styled-components";

export const Card = styled.article`
  width: 320px;
  min-width: 320px;
  max-width: 320px;
  height: 392px;
  border: 1px solid ${({ completed, theme }) => completed ? "rgba(21, 93, 252, 0.42)" : theme.palette.colors.borderSoft};
  border-radius: 8px;
  padding: 12px;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedSoft};
  display: flex;
  flex-direction: column;
  gap: 10px;
  scroll-snap-align: start;
  transition: border-color 0.16s ease, transform 0.16s ease, background 0.16s ease;

  &:hover {
    border-color: rgba(21, 93, 252, 0.34);
    background: ${({ theme }) => theme.palette.colors.surfaceElevated};
    transform: translateY(-2px);
  }

  @media (max-width: 520px) {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
    height: 382px;
  }
`;

export const Thumbnail = styled.div`
  width: 100%;
  height: 148px;
  border-radius: 8px;
  flex: 0 0 auto;
  background:
    linear-gradient(0deg, rgba(2, 6, 24, 0.18), rgba(2, 6, 24, 0.1)),
    url(${({ image }) => image}) center / cover no-repeat;

  @media (max-width: 520px) {
    height: 132px;
  }
`;

export const Meta = styled.div`
  min-height: 25px;
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
`;

export const TypeLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  color: ${({ theme }) => theme.palette.blue.main};
  text-transform: uppercase;
`;

export const RequiredBadge = styled.span`
  border-radius: 999px;
  padding: 5px 7px;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
`;

export const StatusBadge = styled.span`
  margin-left: auto;
  border-radius: 999px;
  padding: 5px 7px;
  background: ${({ completed, theme }) => completed ? theme.palette.blue.main : theme.palette.colors.surfaceElevated};
  color: ${({ completed, theme }) => completed ? "#FFFFFF" : theme.palette.colors.muted};
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  white-space: nowrap;
`;

export const Title = styled.h4`
  margin: 0;
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 18px;
  line-height: 1.32;
  min-height: 48px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 15px;
  line-height: 1.5;
  min-height: 45px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 999px;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.colors.surfaceElevated};
`;

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.palette.blue.main};
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 72px;
  margin-top: auto;
`;

export const ActionButton = styled.button`
  min-height: 42px;
  border: 1px solid ${({ secondary, theme }) => secondary ? theme.palette.colors.border : theme.palette.blue.main};
  border-radius: 8px;
  padding: 0 12px;
  background: ${({ secondary, theme }) => secondary ? "transparent" : theme.palette.blue.main};
  color: ${({ secondary, theme }) => secondary ? theme.palette.colors.text : "#FFFFFF"};
  cursor: pointer;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  flex: ${({ secondary }) => secondary ? "0 0 auto" : "1 1 auto"};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
